import { Icon } from '@chakra-ui/react';

export const DottedLineManagerBold = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M7.40234 12.336C7.40234 11.9198 7.70502 11.5743 8.10224 11.5077L10.624 18.6637C10.6685 18.7898 10.7274 18.9022 10.7978 19.0009H8.22999C7.77289 19.0009 7.40234 18.6303 7.40234 18.1732V12.336ZM15.7208 19.0009H12.9109C12.9782 18.9064 13.0353 18.7993 13.0792 18.6797L15.7105 11.5115C16.1867 11.5952 16.5485 12.0108 16.5485 12.511V18.1732C16.5485 18.6303 16.1779 19.0009 15.7208 19.0009Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path d="M10.9326 13.142L12.031 16.5706L13.1294 13.142L12.031 11.4277L10.9326 13.142Z" fill="currentColor" />
    <path
      d="M14.3265 7.42857C14.3265 8.80763 13.2619 9.85714 12.0314 9.85714C10.8009 9.85714 9.73633 8.80763 9.73633 7.42857C9.73633 6.04951 10.8009 5 12.0314 5C13.2619 5 14.3265 6.04951 14.3265 7.42857Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M18.7861 11.6943V11.6943C20.009 11.6943 21.0003 12.685 21.0003 13.9079C21.0003 14.8572 21.0003 16.0149 21.0003 17.1811C21.0003 18.1905 20.182 19.0088 19.1727 19.0088H18.9363"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M16.5332 4.50809C17.0137 4.00809 18.1223 4.07275 18.4138 4.19839C18.7053 4.32402 18.9701 4.50817 19.1932 4.74032C19.4164 4.97247 19.5933 5.24806 19.7141 5.55138C19.8348 5.85469 19.897 6.17978 19.897 6.50809C19.897 6.83639 19.8348 7.16148 19.7141 7.46479C19.5933 7.76811 19.4164 8.04371 19.1932 8.27585C18.9701 8.508 18.7053 8.69215 18.4138 8.81778C18.1223 8.94342 17.0137 9.00879 16.5332 8.50853"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M5.21387 11.6953V11.6953C3.99102 11.6953 2.9997 12.686 2.9997 13.9089C2.9997 14.8581 2.9997 16.0159 2.9997 17.1821C2.9997 18.1915 3.81797 19.0098 4.82735 19.0098H5.0637"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M7.4668 4.50875C6.98626 4.00875 5.87775 4.07342 5.58624 4.19905C5.29474 4.32469 5.02987 4.50884 4.80676 4.74098C4.58365 4.97313 4.40667 5.24873 4.28592 5.55204C4.16518 5.85536 4.10303 6.18045 4.10303 6.50875C4.10303 6.83706 4.16518 7.16215 4.28592 7.46546C4.40667 7.76877 4.58365 8.04437 4.80676 8.27652C5.883 9.39655 6.84407 9.00977 7.32461 8.5109"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
  </Icon>
);
